import { Manzana10Div1 } from "../manzanas/Manzana10Div1";
import { Manzana11Div1 } from "../manzanas/Manzana11Div1";
import { Manzana12Div1 } from "../manzanas/Manzana12Div1";
import { Manzana13Div1 } from "../manzanas/Manzana13Div1";
import { Manzana14Div1 } from "../manzanas/Manzana14Div1";
import { Manzana15Div1 } from "../manzanas/Manzana15Div1";
import { Manzana15Div2 } from "../manzanas/Manzana15Div2";
import { Manzana15Div3 } from "../manzanas/Manzana15Div3";
import { Manzana16Div1 } from "../manzanas/Manzana16Div1";
import { Manzana17Div1 } from "../manzanas/Manzana17Div1";
import { Manzana18Div1 } from "../manzanas/Manzana18Div1";
import { Manzana19Div1 } from "../manzanas/Manzana19Div1";
import { Manzana1Div1 } from "../manzanas/Manzana1Div1";
import { Manzana1Div2 } from "../manzanas/Manzana1Div2";
import { Manzana20Div1 } from "../manzanas/Manzana20Div1";
import { Manzana21Div1 } from "../manzanas/Manzana21Div1";
import { Manzana22Div1 } from "../manzanas/Manzana22Div1";
import { Manzana23Div1 } from "../manzanas/Manzana23Div1";
import { Manzana24Div1 } from "../manzanas/Manzana24Div1";
import { Manzana25Div1 } from "../manzanas/Manzana25Div1";
import { Manzana26Div1 } from "../manzanas/Manzana26Div1";
import { Manzana27Div1 } from "../manzanas/Manzana27Div1";
import { Manzana28Div1 } from "../manzanas/Manzana28Div1";
import { Manzana29Div1 } from "../manzanas/Manzana29Div1";
import { Manzana2Div1 } from "../manzanas/Manzana2Div1";
import { Manzana30Div1 } from "../manzanas/Manzana30Div1";
import { Manzana31Div1 } from "../manzanas/Manzana31Div1";
import { Manzana32Div1 } from "../manzanas/Manzana32Div1";
import { Manzana33Div1 } from "../manzanas/Manzana33Div1";
import { Manzana34Div1 } from "../manzanas/Manzana34Div1";
import { Manzana35Div1 } from "../manzanas/Manzana35Div1";
import { Manzana35Div2 } from "../manzanas/Manzana35Div2";
import { Manzana35Div3 } from "../manzanas/Manzana35Div3";
import { Manzana36Div1 } from "../manzanas/Manzana36Div1";
import { Manzana37Div1 } from "../manzanas/Manzana37Div1";
import { Manzana38Div1 } from "../manzanas/Manzana38Div1";
import { Manzana3Div1 } from "../manzanas/Manzana3Div1";
import { Manzana4Div1 } from "../manzanas/Manzana4Div1";
import { Manzana5Div1 } from "../manzanas/Manzana5Div1";
import { Manzana6Div1 } from "../manzanas/Manzana6Div1";
import { Manzana7Div1 } from "../manzanas/Manzana7Div1";
import { Manzana8Div1 } from "../manzanas/Manzana8Div1";
import { Manzana9Div1 } from "../manzanas/Manzana9Div1";

const style = {
  width: "100%",
  height: "100%",
};

export const manzanas = [
  {
    manzana: "1",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
      "47",
      "48",
      "49",
      "50",
      "51",
      "52",
      "53",
      "54",
      "55",
      "56",
      "57",
      "58",
      "59",
      "60",
    ],
    render: (lands, landSelected, maxLotes) => {
      if (maxLotes <= 20) {
        return (
          <Manzana1Div1 lands={lands} selected={landSelected} style={style} />
        );
      }

      return (
        <Manzana1Div2 lands={lands} selected={landSelected} style={style} />
      );
    },
  },
  {
    manzana: "2",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
    render: (lands, landSelected) => (
      <Manzana2Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "3",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
    ],
    render: (lands, landSelected) => (
      <Manzana3Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "4",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
    ],
    render: (lands, landSelected) => (
      <Manzana4Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "5",
    lotesId: ["1", "2"],
    render: (lands, landSelected) => (
      <Manzana5Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "6",
    lotesId: ["1", "2", "3", "4", "5", "6", "7"],
    render: (lands, landSelected) => (
      <Manzana6Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "7",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
    render: (lands, landSelected) => (
      <Manzana7Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "8",
    lotesId: ["1", "2", "3", "4", "5"],
    render: (lands, landSelected) => (
      <Manzana8Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "9",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
    ],
    render: (lands, landSelected) => (
      <Manzana9Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "10",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
    ],
    render: (lands, landSelected) => (
      <Manzana10Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "11",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
    render: (lands, landSelected) => (
      <Manzana11Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "12",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
    render: (lands, landSelected) => (
      <Manzana12Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "13",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
    ],
    render: (lands, landSelected) => (
      <Manzana13Div1 lands={lands} selected={landSelected} />
    ),
  },
  {
    manzana: "14",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"],
    render: (lands, landSelected) => (
      <Manzana14Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "15",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "42",
      "43",
    ],
    render: (lands, landSelected, maxLotes) => {
      if (maxLotes <= 10) {
        return (
          <Manzana15Div1 lands={lands} selected={landSelected} style={style} />
        );
      }

      if (maxLotes >= 28) {
        return (
          <Manzana15Div3 lands={lands} selected={landSelected} style={style} />
        );
      }

      return (
        <Manzana15Div2 lands={lands} selected={landSelected} style={style} />
      );
    },
  },
  {
    manzana: "16",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
    render: (lands, landSelected) => (
      <Manzana16Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "17",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
    render: (lands, landSelected) => (
      <Manzana17Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "18",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
    render: (lands, landSelected) => (
      <Manzana18Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "19",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
    ],
    render: (lands, landSelected) => (
      <Manzana19Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "20",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
    ],
    render: (lands, landSelected) => (
      <Manzana20Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "21",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8"],
    render: (lands, landSelected) => (
      <Manzana21Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "22",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8"],
    render: (lands, landSelected) => (
      <Manzana22Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "23",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"],
    render: (lands, landSelected) => (
      <Manzana23Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "24",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
    render: (lands, landSelected) => (
      <Manzana24Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "25",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
    render: (lands, landSelected) => (
      <Manzana25Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "26",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
    ],
    render: (lands, landSelected) => (
      <Manzana26Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "27",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
    ],
    render: (lands, landSelected) => (
      <Manzana27Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "28",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
    ],
    render: (lands, landSelected) => (
      <Manzana28Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "29",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8"],
    render: (lands, landSelected) => (
      <Manzana29Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "30",
    lotesId: ["1", "2", "3"],
    render: (lands, landSelected) => (
      <Manzana30Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "31",
    lotesId: ["1", "2", "3", "4"],
    render: (lands, landSelected) => (
      <Manzana31Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "32",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
    ],
    render: (lands, landSelected) => (
      <Manzana32Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "33",
    lotesId: ["1", "2", "3", "4"],
    render: (lands, landSelected) => (
      <Manzana33Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "34",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
    ],
    render: (lands, landSelected) => (
      <Manzana34Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "35",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
    ],
    render: (lands, landSelected, maxLotes) => {
      if (maxLotes <= 9) {
        return (
          <Manzana35Div1 lands={lands} selected={landSelected} style={style} />
        );
      }
      if (maxLotes <= 21) {
        return (
          <Manzana35Div2 lands={lands} selected={landSelected} style={style} />
        );
      }
      return (
        <Manzana35Div3 lands={lands} selected={landSelected} style={style} />
      );
    },
  },
  {
    manzana: "36",
    lotesId: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
    ],
    render: (lands, landSelected) => (
      <Manzana36Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "37",
    lotesId: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"],
    render: (lands, landSelected) => (
      <Manzana37Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "38",
    lotesId: ["1", "2", "3", "4", "5", "6", "7"],
    render: (lands, landSelected) => (
      <Manzana38Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
  {
    manzana: "39",
    lotesId: ["1", "2", "3", "4", "5", "6", "7"],
    render: (lands, landSelected) => (
      <Manzana38Div1 lands={lands} selected={landSelected} style={style} />
    ),
  },
];
